// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pill[data-v-7870c942]{color:#fff;font-size:10px;padding:2px 6px;border-radius:9px}@media only screen and (min-width:737px){.pill[data-v-7870c942]{font-size:12px}}", ""]);
// Exports
module.exports = exports;
